import makeActionCreator from '../../utils/makeActionCreator'
import fetch from 'isomorphic-fetch'
import { sessionService } from 'redux-react-session';
import { browserHistory } from 'react-router'

import * as API       from '../../utils/config-api'
import * as endpoints from './endpoints'
import { logout } from '../../auth/list';

export const SETTINGS_IMPORT_PENDING = 'SETTINGS_IMPORT_PENDING'
export const settingsImportPending = makeActionCreator(SETTINGS_IMPORT_PENDING)

export const SETTINGS_IMPORT_REJECTED = 'SETTINGS_IMPORT_REJECTED'
export const settingsImportRejected = makeActionCreator(SETTINGS_IMPORT_REJECTED)

export const SETTINGS_IMPORT_SHOW_LIST= 'SETTINGS_IMPORT_SHOW_LIST'
export const settingsImportShowList = makeActionCreator(SETTINGS_IMPORT_SHOW_LIST)

export const SETTINGS_IMPORT_HIDE_LIST = 'SETTINGS_IMPORT_HIDE_LIST'
export const settingsImportHideList = makeActionCreator(SETTINGS_IMPORT_HIDE_LIST)

export const SETTINGS_IMPORT_SHOW_FORM= 'SETTINGS_IMPORT_SHOW_FORM'
export const settingsImportShowForm = makeActionCreator(SETTINGS_IMPORT_SHOW_FORM, 'itemId')

export const SETTINGS_IMPORT_HIDE_FORM = 'SETTINGS_IMPORT_HIDE_FORM'
export const settingsImportHideForm = makeActionCreator(SETTINGS_IMPORT_HIDE_FORM)

export const SETTINGS_IMPORT_SHOW_ITEM = 'SETTINGS_IMPORT_SHOW_ITEM'
export const settingsImportShowItem = makeActionCreator(SETTINGS_IMPORT_SHOW_ITEM, 'itemId')


//Show Index

export const SETTINGS_IMPORT_LIST_FULFILLED = 'SETTINGS_IMPORT_LIST_FULFILLED'
export const settingsImportListFulfilled = makeActionCreator(SETTINGS_IMPORT_LIST_FULFILLED, 'data')

export const SETTINGS_IMPORT_LIST_ERROR = 'SETTINGS_IMPORT_LIST_ERROR'
export const settingsImportListError = makeActionCreator(SETTINGS_IMPORT_LIST_ERROR, 'message')

export function settingsImportList() {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsImportPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.index.version}${endpoints.index.path}`, {
              method  : endpoints.index.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsImportListFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsImportRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

// Import Data
export const SETTINGS_IMPORT_PROCESS_FULFILLED = 'SETTINGS_IMPORT_PROCESS_FULFILLED'
export const settingsImportProcessFulfilled = makeActionCreator(SETTINGS_IMPORT_PROCESS_FULFILLED, 'data')

export const SETTINGS_IMPORT_PROCESS_ERROR = 'SETTINGS_IMPORT_PROCESS_ERROR'
export const settingsImportProcessError = makeActionCreator(SETTINGS_IMPORT_PROCESS_ERROR, 'message')

export function settingsImportProcess() {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsImportPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.processData.version}${endpoints.processData.path}`, {
              method  : endpoints.processData.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsImportProcessFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsImportProcessError(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

export const SETTINGS_IMPORT_PROCESS_HIDE_SUCCESS = 'SETTINGS_IMPORT_PROCESS_HIDE_SUCCESS'
export const settingsImportHideSuccess = makeActionCreator(SETTINGS_IMPORT_PROCESS_HIDE_SUCCESS)






//Show Item

export const SETTINGS_IMPORT_ITEM_FULFILLED = 'SETTINGS_IMPORT_ITEM_FULFILLED'
export const settingsImportItemFulfilled = makeActionCreator(SETTINGS_IMPORT_ITEM_FULFILLED, 'data')

export const SETTINGS_IMPORT_ITEM_ERROR = 'SETTINGS_IMPORT_ITEM_ERROR'
export const settingsImportItemError = makeActionCreator(SETTINGS_IMPORT_ITEM_ERROR, 'message')

export function settingsImportItem(itemId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsImportPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.getItem.version}${endpoints.getItem.path.replace(":recruit_stages_id", itemId)}`, {
              method  : endpoints.getItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsImportItemFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsImportRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}


//Add Item

export const SETTINGS_IMPORT_ITEM_ADD_FULFILLED = 'SETTINGS_IMPORT_ITEM_ADD_FULFILLED'
export const settingsImportItemAddFulfilled = makeActionCreator(SETTINGS_IMPORT_ITEM_ADD_FULFILLED, 'data')

export const SETTINGS_IMPORT_ITEM_ADD_ERROR = 'SETTINGS_IMPORT_ITEM_ADD_ERROR'
export const settingsImportItemAddError = makeActionCreator(SETTINGS_IMPORT_ITEM_ADD_ERROR, 'message')

export function settingsImportAddItem(data) {
  let formData = new FormData()

  Object.keys(data).map((key)=> {
    formData.append(key, data[key]);
    return key;
  });

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsImportPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.addItem.version}${endpoints.addItem.path}`, {
              method  : endpoints.addItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingsImportItemAddFulfilled(json.data))
              }else{
                dispatch(settingsImportItemAddError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsImportRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Update Item

export const SETTINGS_IMPORT_ITEM_UPDATE_FULFILLED = 'SETTINGS_IMPORT_ITEM_UPDATE_FULFILLED'
export const settingsImportItemUpdateFulfilled = makeActionCreator(SETTINGS_IMPORT_ITEM_UPDATE_FULFILLED, 'data')

export const SETTINGS_IMPORT_ITEM_UPDATE_ERROR = 'SETTINGS_IMPORT_ITEM_UPDATE_ERROR'
export const settingsImportItemUpdateError = makeActionCreator(SETTINGS_IMPORT_ITEM_UPDATE_ERROR, 'message')

export function settingsImportUpdateItem(itemId, data) {
  let formData = new FormData()
  formData.append('_method', 'PUT')

  Object.keys(data).map((key)=> {
    formData.append(key, data[key]);
    return key;
  });


  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsImportPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.updateItem.version}${endpoints.updateItem.path.replace(":recruit_stages_id", itemId)}`, {
              method  : endpoints.updateItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingsImportItemUpdateFulfilled(json.data))
              }else{
                dispatch(settingsImportItemUpdateError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsImportRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Delete Item

export const SETTINGS_IMPORT_ITEM_DELETE_FULFILLED = 'SETTINGS_IMPORT_ITEM_DELETE_FULFILLED'
export const settingsImportItemDeleteFulfilled = makeActionCreator(SETTINGS_IMPORT_ITEM_DELETE_FULFILLED, 'data')

export const SETTINGS_IMPORT_ITEM_DELETE_ERROR = 'SETTINGS_IMPORT_ITEM_DELETE_ERROR'
export const settingsImportItemDeleteError = makeActionCreator(SETTINGS_IMPORT_ITEM_DELETE_ERROR, 'message')

export function settingsImportDeleteItem(itemId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsImportPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.deleteItem.version}${endpoints.deleteItem.path.replace(":recruit_stages_id", itemId)}`, {
              method  : endpoints.deleteItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
            if(json.status === "ok"){
              dispatch(settingsImportItemDeleteFulfilled(json.data))
              dispatch(settingsImportList())
            }else{
              dispatch(settingsImportItemDeleteError(json.message))
            }

          })
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsImportRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })





  }
}
